import React, { FC } from 'react'

// Utils
import noop from 'utils/noop'

// Components
import Button from 'components/Button'

// Styles
import {
  Text,
  SketchLogoBlack,
  SketchLogoText,
  Modal,
} from './SubscriptionDoneModal.styles'

// Types
import { ModalInjectedProps } from 'containers/ModalManager'

interface SubscriptionDoneModalProps extends ModalInjectedProps {
  onHide: () => void
}

const SubscriptionDoneModal: FC<SubscriptionDoneModalProps> = ({ onHide }) => {
  return (
    <Modal onCancel={noop}>
      <Modal.Header>You’re All Set!</Modal.Header>
      <Modal.Body>
        <Text>
          Thanks for subscribing to <SketchLogoBlack width="18.78px" />
          <SketchLogoText>Sketch</SketchLogoText>
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary-untinted" onClick={onHide}>
          Go to Workspace
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SubscriptionDoneModal
